import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportClockIn_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportClockIn extends Report<ReportClockIn_Settings> {

    static reportName   : string = "Clock-in report"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_CLOCK_IN
        super(data);

        this.icon           = "isvg-clock-in"
        this.name           = data.name || "Check-In Report"
        this.description    = "Displays the total number of check-ins by location and recorded days off, providing insights into attendance trends and team presence."

        this.settings       = new ReportClockIn_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportClockIn {
        return new ReportClockIn(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportClockIn_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
